import { useEffect } from 'react';
import { useLocation } from '@reach/router';

import { useCookieConsent } from '~/context/CookieConsentContext';

declare global {
  interface Window {
    instgrm?: {
      Embeds: {
        process(): void;
      };
    };
  }
}

const EMBED_JS_URL = 'https://www.instagram.com/embed.js';
const SCRIPT_ID = 'instagram-embed-js';

function loadEmbedScript(): void {
  if (document.getElementById(SCRIPT_ID)) {
    // Script already present — re-process any embeds added since last load
    window.instgrm?.Embeds.process();
    return;
  }

  const script = document.createElement('script');
  script.id = SCRIPT_ID;
  script.src = EMBED_JS_URL;
  script.async = true;
  script.onload = () => window.instgrm?.Embeds.process();
  document.body.appendChild(script);
}

const InstagramEmbedLoader: React.FC = () => {
  const { consentStatus } = useCookieConsent();
  const { pathname } = useLocation();

  useEffect(() => {
    if (
      consentStatus === 'accepted' &&
      document.querySelector('.instagram-media') !== null
    ) {
      loadEmbedScript();
    }
  }, [consentStatus, pathname]);

  return null;
};

export default InstagramEmbedLoader;
